export default __webpack_public_path__ + "static/media/img-4.180478ff.png";